import React, { useState } from 'react'
import styled from 'styled-components'
import { FieldWrapper } from '@progress/kendo-react-form'
import { ComboBox } from '@progress/kendo-react-dropdowns'
import { Label } from '@progress/kendo-react-labels'

export default (fieldRenderProps) => {
    const { label, valid, disabled, data, ...others } = fieldRenderProps
    const [filteredData, setFilteredData] = useState(data)

    const changeFilter = ({filter}) => {
        const filterValue = filter.value.toLowerCase()
        setFilteredData(data.filter(entry => entry.toLowerCase().indexOf(filterValue) !== -1))
    }

    if (others.filterable && !others.onFilterChange) {
        others.onFilterChange = changeFilter
    }
    return <FieldWrapper>
        <StyledLabel editorValid={valid} editorDisabled={disabled}>{label}</StyledLabel>
        <StyledComboBox data={filteredData} {...others} />
    </FieldWrapper>
}

const StyledLabel = styled(Label)`
    font-size: 12px;
    color: rgba(0,0,0,0.6);
    display: block;
    padding-top: 4px;
`

const StyledComboBox = styled(ComboBox)`
    width: ${props => props.width ? props.width : '200px'};
`



// WEBPACK FOOTER //
// ./src/components/common/ComboBoxField.js